import { type QueryHookOptions, useQuery } from "@apollo/client";
import { PlatformMenuItemsListQuery } from "../graphql/queries";
import type { PlatformMenuItemsListQueryType } from "@/types/graphql/partner.generated";

export const usePlatformMenuItemsQuery = (
  options?: QueryHookOptions<PlatformMenuItemsListQueryType>
) => {
  return useQuery<PlatformMenuItemsListQueryType>(
    PlatformMenuItemsListQuery,
    options
  );
};
